import React from 'react';
import { motion } from 'framer-motion';
import { PROFILE_DATA, TECH_STACK } from '../../data/config';
import { Award, Briefcase, Target } from 'lucide-react';

const EASE = [0.22, 1, 0.36, 1];

const STAT_CARDS = [
  { icon: Briefcase, value: null, label: 'Years Experience', useYears: true },
  { icon: Award, value: '20+', label: 'Products Shipped' },
  { icon: Target, value: '99.8%', label: 'Uptime' },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.05 } },
};
const item = {
  hidden: { opacity: 0, y: 14 },
  show: { opacity: 1, y: 0, transition: { duration: 0.35, ease: EASE } },
};

const About = () => {
  return (
    <section id="about" className="section-container">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-20 max-w-3xl">
          <p className="text-[0.7rem] uppercase tracking-[0.4em] text-coffee-300 mb-5">About</p>
          <h2 className="text-5xl md:text-7xl font-bold mb-8 gradient-text leading-[1.05]">
            Hello.
          </h2>
          <p className="text-xl md:text-2xl text-cream-200/85 leading-relaxed">
            {PROFILE_DATA.bio}
          </p>
        </div>

        {/* Stats — clean horizontal row */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-px bg-cream-100/8 rounded-2xl overflow-hidden border border-cream-100/8 mb-20"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-80px' }}
        >
          {STAT_CARDS.map((stat) => {
            const Icon = stat.icon;
            const value = stat.useYears
              ? `${PROFILE_DATA.yearsOfExperience}+`
              : stat.value;
            return (
              <motion.div
                key={stat.label}
                variants={item}
                className="bg-espresso-900/80 p-8 md:p-10"
              >
                <Icon className="w-5 h-5 text-caramel-400 mb-5" />
                <div className="text-5xl md:text-6xl font-bold gradient-text mb-2 leading-none">
                  {value}
                </div>
                <div className="text-[0.7rem] uppercase tracking-[0.2em] text-coffee-300">
                  {stat.label}
                </div>
              </motion.div>
            );
          })}
        </motion.div>

        {/* Stack */}
        <div>
          <p className="text-[0.7rem] uppercase tracking-[0.4em] text-coffee-300 mb-6">Stack</p>
          <motion.div
            className="flex flex-wrap gap-2"
            variants={container}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: '-50px' }}
          >
            {TECH_STACK.map((skill) => (
              <motion.span key={skill.name} variants={item} className="tech-badge">
                {skill.name}
              </motion.span>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
